import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import './reassurance.styles.scss'

const Reassurance = ({ location, ...otherProps }) => {
  const { t } = useTranslation('updatedBAB')

  const isRouteReassurance = location === 'routes'
  const isStickyButtonReassurance = location === 'sticky-button'
  const reassuranceSlides = t('reassurance', { returnObjects: true })

  // Gestion de la rotation des annonces
  const reassuranceSlidesRef = useRef(null)

  useEffect(() => {
    setInterval(() => {
      const slides = reassuranceSlidesRef.current
      const bullets = slides.nextElementSibling
      let currentSlide = slides.firstElementChild

      if (currentSlide.hasAttribute('data-copy')) {
        currentSlide.remove()
        currentSlide = slides.firstElementChild

        const slideWidth = currentSlide.offsetWidth
        slides.scroll({ left: slideWidth })

        const slideIndex = currentSlide.getAttribute('data-index')
        const associatedBullet = bullets.querySelector(
          `[data-index="${slideIndex}"`
        )

        bullets.childNodes.forEach((bullet) =>
          bullet.removeAttribute('data-active')
        )
        associatedBullet.setAttribute('data-active', '')
      }

      setTimeout(() => {
        slides.append(currentSlide.cloneNode(true))
        slides.firstElementChild.setAttribute('data-copy', '')
      }, 1200)
    }, 3000)
  }, [])

  return (
    <div
      className='reassurance'
      data-routes={isRouteReassurance ? '' : null}
      data-sticky-button={isStickyButtonReassurance ? '' : null}
    >
      <div className='reassurance-slides' ref={reassuranceSlidesRef}>
        {Object.values(reassuranceSlides).map((slide, index) => (
          <p className='reassurance-slide' data-index={index} key={index}>
            {slide.heading}
            <span>{slide.text}</span>
          </p>
        ))}
      </div>
      <div className='reassurance-bullets'>
        {Object.values(reassuranceSlides).map((_, index) => (
          <div
            className='reassurance-bullet'
            key={index}
            data-index={index}
            data-active={index === 0 ? 'true' : undefined}
          />
        ))}
      </div>
    </div>
  )
}

export default Reassurance
